(function (module) {
    'use strict';

    module.directive('autofocus', ($timeout) => {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                $timeout(function () {
                    $element[0].focus();
                });
            }
        };
    });

})(angular.module('rocket.components'));
